import React from "react";

function ErrorIcon() {
  return (
    <div className="text-sunny-border dark:text-dark-text dark:opacity-60 ">
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28 41.75C28.7792 41.75 29.4323 41.4865 29.9594 40.9594C30.4865 40.4323 30.75 39.7792 30.75 39C30.75 38.2208 30.4865 37.5677 29.9594 37.0406C29.4323 36.5135 28.7792 36.25 28 36.25C27.2208 36.25 26.5677 36.5135 26.0406 37.0406C25.5135 37.5677 25.25 38.2208 25.25 39C25.25 39.7792 25.5135 40.4323 26.0406 40.9594C26.5677 41.4865 27.2208 41.75 28 41.75ZM25.25 30.75H30.75V14.25H25.25V30.75ZM28 55.5C24.1958 55.5 20.6208 54.7781 17.275 53.3344C13.9292 51.8906 11.0187 49.9312 8.54375 47.4562C6.06875 44.9812 4.10937 42.0708 2.66562 38.725C1.22187 35.3792 0.5 31.8042 0.5 28C0.5 24.1958 1.22187 20.6208 2.66562 17.275C4.10937 13.9292 6.06875 11.0187 8.54375 8.54375C11.0187 6.06875 13.9292 4.10937 17.275 2.66562C20.6208 1.22187 24.1958 0.5 28 0.5C31.8042 0.5 35.3792 1.22187 38.725 2.66562C42.0708 4.10937 44.9812 6.06875 47.4562 8.54375C49.9312 11.0187 51.8906 13.9292 53.3344 17.275C54.7781 20.6208 55.5 24.1958 55.5 28C55.5 31.8042 54.7781 35.3792 53.3344 38.725C51.8906 42.0708 49.9312 44.9812 47.4562 47.4562C44.9812 49.9312 42.0708 51.8906 38.725 53.3344C35.3792 54.7781 31.8042 55.5 28 55.5Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}

export default ErrorIcon;
